import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The app's tabs, in one place so adding one does not mean editing five
 * screens and forgetting the mobile menu.
 *
 * Two variants, because the header nav is hidden below 768px to make room
 * for the hamburger — rendering that same element inside the mobile menu
 * would inherit the rule and show nothing at all.
 */
const TABS = [
  { key: 'profile', to: '/connect/profile', label: 'Profile' },
  { key: 'connect', to: '/connect/discover', label: 'Connect' },
  { key: 'meet', to: '/connect/meet', label: 'Meet' },
  { key: 'messages', to: '/connect/messages', label: 'Messages' },
];

export default function ConnectNav({ active, onNavigate, variant = 'header' }) {
  const links = TABS.map((tab) => (
    <Link
      key={tab.key}
      to={tab.to}
      className={`connect-nav-link ${active === tab.key ? 'active' : ''}`}
      aria-current={active === tab.key ? 'page' : undefined}
      onClick={onNavigate}
    >
      {tab.label}
    </Link>
  ));

  if (variant === 'mobile') {
    // No .connect-profile-nav here: that class is display:none on mobile.
    return <>{links}</>;
  }

  return <nav className="connect-profile-nav">{links}</nav>;
}
